<template>
  <v-container
    fluid
  >

      <v-tabs fixed-tabs hide-slider v-model="activeTab"  >
        <v-tab key="tab-1" :to="{ name: 'ProjectShow', params: { 'id': id }}">

          {{$t('projects.submenu.projectDetails')}}
        </v-tab>
        <v-tab key="tab-2" :to="{ name: 'ProjectBarrierChecklist', params: { 'id': id }}">
          {{$t('projects.submenu.barrierChecklist')}}
        </v-tab>
        <v-tab  key="tab-3" :to="{ name: 'ProjectRiskAnalysisSummary', params: { 'id': id }}">
          {{$t('projects.submenu.riskAnalysis')}}
        </v-tab>


      </v-tabs>
    <v-row justify="center">
      <v-col>
        <v-card-text>
          <h2 class="font-weight-light mb-4">
            {{projectName}}
          </h2>



          <v-row>
            <v-col cols="3">
              <div class="h2 font-weight-bold">

              {{$t('project.name')}}:
              </div>
            </v-col>
            <v-col cols="8">
              {{projectName}}
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              <div class="h2 font-weight-bold">

              {{$t('project.projectNumber')}}:
              </div>
            </v-col>
            <v-col cols="8">
              {{projectNumber}}
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              <div class="h2 font-weight-bold">

              {{$t('project.projectType')}}:
              </div>
            </v-col>
            <v-col cols="8">
              {{projectType}}
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              <div class="h2 font-weight-bold">

              {{$t('project.language')}}:
              </div>
            </v-col>
            <v-col cols="8">
              {{projectLanguage}}
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              <div class="h2 font-weight-bold">

                {{$t('project.department')}}:
              </div>
            </v-col>
            <v-col cols="8">
              {{department}}
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              <div class="h2 font-weight-bold">

              {{$t('project.active')}}:
              </div>
            </v-col>
            <v-col cols="8">
              <span v-if="this.active">{{$t('global.yes')}}</span><span v-else>{{$t('global.no')}}</span>
              &nbsp;
              <v-btn icon
                     v-if="userHasAuthority('MANAGE_PROJECTS')"
                     @click="switchActiveStatus">
                <v-icon >mdi-autorenew</v-icon>

              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              <div class="h2 font-weight-bold">

                {{$t('project.lastEdited')}}:
              </div>
            </v-col>
            <v-col cols="8">
              {{lastEdited}}
            </v-col>
          </v-row>
        </v-card-text>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-btn
          v-if="userHasAuthority('MANAGE_PROJECTS')"
          :to="{ name: 'ProjectEdit', params: { 'id': id }}">
          {{$t("projects.show.edit")}}
        </v-btn>
        &nbsp;<v-btn
        v-if="userHasAuthority('MANAGE_PROJECTS')"
        @click="cloneProject">{{$t('projects.show.clone')}}</v-btn>
        &nbsp;<v-btn
        v-if="userHasAuthority('MANAGE_SETTINGS')"
        @click="openDeleteDialogue">{{$t('projects.show.delete')}}</v-btn>


      </v-col>
      <!--
      <v-col>
        <v-btn
          :to="{ name: 'BarriersInOperation', params: { 'id': id }}">
          {{$t("projects.show.barriersInOperation")}}
        </v-btn>

      </v-col>-->
    </v-row>

    <v-row>
      <v-col cols="6">
        {{$t("projects.show.riskBeforeMeasures")}}
        <v-simple-table >
          <tbody>
          <tr><th></th><th  v-for="cons in consequenceStrengths">{{cons.name}}</th> </tr>

          <tr v-for="level in probabilityLevels.slice().reverse()">
            <th   scope="row">{{level.name}}</th>
            <td  @click="filterIncidentsOnRiskBefore(cons.id, level.id)" v-for="cons in consequenceStrengths" :class="getRiskColor(level.id,cons.id)">
              <div v-if="(selectedCons==cons.id && selectedLevel==level.id && filterOnRiskBefore && filteredView)" class="headline font-weight-bold">
              {{
              incidentsPerCellBefore[cons.id-1][level.id-1]>0?incidentsPerCellBefore[cons.id-1][level.id-1]:''}}
              </div>
                <div v-else>
                  {{
                  incidentsPerCellBefore[cons.id-1][level.id-1]>0?incidentsPerCellBefore[cons.id-1][level.id-1]:''}}

              </div>

            </td>
          </tr>

          </tbody>
        </v-simple-table>

      </v-col>


      <v-col cols="6">
        {{$t("projects.show.riskAfterMeasures")}}
        <v-simple-table >
          <tbody>
          <tr><th></th><th v-for="cons in consequenceStrengths">{{cons.name}}</th> </tr>

          <tr v-for="level in probabilityLevels.slice().reverse()">
            <th  scope="row">{{level.name}}</th>
            <td @click="filterIncidentsOnRiskAfter(cons.id, level.id)" v-for="cons in consequenceStrengths"  :class="getRiskColor(level.id,cons.id)">
              <div v-if="(selectedCons==cons.id && selectedLevel==level.id && !filterOnRiskBefore && filteredView)" class="headline font-weight-bold">

                {{ incidentsPerCellAfter[cons.id-1][level.id-1]>0?incidentsPerCellAfter[cons.id-1][level.id-1]:''}}
              </div>
              <div v-else>
                {{ incidentsPerCellAfter[cons.id-1][level.id-1]>0?incidentsPerCellAfter[cons.id-1][level.id-1]:''}}

              </div>




            </td>
          </tr>

          </tbody>
        </v-simple-table>

      </v-col>
    </v-row>


    <!-- potentialIncidents   -->
    <v-row>
      <v-col>
        <v-btn :disabled="!filteredView"
               @click="clearFilterOnIncidents">
          {{$t("projects.show.potentialIncidents.clearFilter")}}
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">


          <v-data-table
            v-model = "selectedRows"
            :headers="headers"
            :items="potentialIncidentsFiltered"
            :search="search"
            @click:row="showPotentialIncident"
            hide-default-footer
            :show-select ="userHasAuthority('MANAGE_PROJECTS')"
            :items-per-page=1000>

            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>{{$t("projects.show.potentialIncidents.list.title")}}</v-toolbar-title>
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>
                <v-text-field

                  :label="$t('global.search')"
                  single-line
                  hide-details
                  v-model="search"
                ></v-text-field>
                <v-spacer></v-spacer>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                          <v-btn class="mb-2"
                                 v-if="userHasAuthority('MANAGE_PROJECTS')"
                                 :disabled="selectedRows.length==0"
                                 v-on="on"
                                 @click="openCopyToProjectDialogue()">
                            <v-icon color="tertiary">
                              mdi-content-copy
                            </v-icon>
                          </v-btn>
                  </template>
                       <span> {{$t("projects.show.potentialIncidents.copyToProject")}}</span>
                </v-tooltip>
                &nbsp;
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="mb-2"
                           v-if="userHasAuthority('MANAGE_PROJECTS')"
                           :disabled="selectedRows.length==0"
                           v-on="on"
                           @click="openDeleteMultipleDialogue()">
                      <v-icon color="tertiary">
                        mdi-delete
                      </v-icon>

                    </v-btn>
                  </template>
                  <span>  {{$t("projects.show.potentialIncidents.delete")}}</span>
                &nbsp;</v-tooltip>
                &nbsp;
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="mb-2"
                           v-if="userHasAuthority('MANAGE_PROJECTS')"
                           v-on="on"
                           :to="{ name: 'potentialIncidentCreateForProject', params: { 'projectId': id }}">
                      <v-icon color="tertiary">
                        mdi-plus
                      </v-icon>
                    </v-btn>
                  </template>
                  <span> {{$t("projects.show.potentialIncidents.create")}}</span>


                </v-tooltip>


              </v-toolbar>
            </template>

<!--
            <template v-slot:item.workTypeName="{ item }">
              {{item.workType.name}}
            </template>

            <template v-slot:item.workOperationName="{ item }">
              {{item.workOperation.name}}
            </template>

            <template v-slot:item.locationName="{ item }">
              {{item.location.name}}
            </template>


            <template v-slot:item.incidentTypeName="{ item }">
              {{item.incidentType.name}}
            </template>

            <template v-slot:item.consequenceTypeName="{ item }">
              {{item.consequenceType.name}}
            </template>
-->

                     <template v-slot:item.risk="{ item }">
              <div :class="getRiskColor(item.probability.id, item.consequence.id)" >{{item.risk}}</div>
            </template>
            <template v-slot:item.riskAfterMeasures="{ item }">
              <div :class="getRiskColor(getLevel(item.probabilityAfterMeasures), getLevel(item.consequenceAfterMeasures))">{{item.riskAfterMeasures}}</div>
            </template>

            <template v-slot:item.delete="{ item }">
              <v-icon @click.stop="openPotentialIncidentDeleteDialogue(item.id)">mdi-delete</v-icon>
            </template>
          </v-data-table>
      </v-col>
    </v-row>

    <v-dialog
      v-model="deletedialog"
      max-width="400"
    >
      <v-card>
        <v-card-title  v-if="this.deleteId==0" class="headline">{{$t("projects.show.deleteDialogue.header")}}</v-card-title>
        <v-card-title  v-else class="headline">{{$t("projects.show.deletePotenitalIncidentDialogue.header")}}</v-card-title>

        <v-card-text>
          <div v-if="this.deleteId==0">{{$t("projects.show.deleteDialogue.body")}}</div>
          <div v-else>{{$t("projects.show.deletePotenitalIncidentDialogue.body")}}</div>
        </v-card-text>

        <v-card-actions>
          <div class="flex-grow-1"></div>

          <v-btn
            text
            @click="closeDialogue"
          >
            {{$t("global.deleteDialogue.cancel")}}
          </v-btn>


          <v-btn
            v-if="this.deleteId==0"
            color="success"
            text
            @click="confirmDeleteProject"
          >
            {{$t("global.deleteDialogue.confirm")}}
          </v-btn>
          <v-btn v-else
                 color="success"
                 text
                 @click="confirmDeletePotentialIncident"
          >
            {{$t("global.deleteDialogue.confirm")}}

          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog
      v-model="deleteMultipleDialog"
      max-width="400"
    >
      <v-card>
        <v-card-title  class="headline">{{$t("projects.show.deleteMultipleDialogue.header")}}</v-card-title>

        <v-card-text>
          <div>{{$t("projects.show.deleteMultipleDialogue.body")}}</div>
         </v-card-text>

        <v-card-actions>
          <div class="flex-grow-1"></div>

          <v-btn
            text
            @click="closeDialogue"
          >
            {{$t("global.deleteDialogue.cancel")}}
          </v-btn>


          <v-btn
            color="success"
            text
            @click="confirmDeleteMultiplePotentialIncidencts"
          >
            {{$t("global.deleteDialogue.confirm")}}
          </v-btn>


        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="copytoproject.enabled"
      max-width="400">

      <v-card>
        <v-card-title  class="headline">{{$t("projects.show.copyToProjectsDialogue.header")}} </v-card-title>

        <v-card-text>


        <v-data-table
          v-model="copytoproject.selectedRows"
          :headers="copytoproject.headers"
          :items="copytoproject.projects"
          :search="copytoproject.search"
          hide-default-footer
          show-select
          single-select
          :items-per-page=1000
        >

          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-divider
                class="mx-4"
                inset
                vertical
              ></v-divider>
              <v-text-field
                :label="$t('global.search')"
                single-line
                hide-details
                v-model="copytoproject.search"
              ></v-text-field>

            </v-toolbar>
          </template>

        </v-data-table>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>

          <v-btn
            text
            :disabled="copytoproject.working"
            @click="closeDialogue"
          >
            {{$t("global.deleteDialogue.cancel")}}
          </v-btn>


          <v-btn
            color="success"
            text
            :disabled="copytoproject.selectedRows.length==0 || copytoproject.working"
            @click="confirmCopyIncidentsToPortal"
          >
            {{$t("global.deleteDialogue.confirm")}}
          </v-btn>


        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>

    import api from '../components/backend/backend-api'
    import languageUtil from '../utils/language'
    import riskUtil from '../utils/riskutil'


    export default {
        data() {
            return {
              filterOnRiskBefore:false,
              selectedCons:-1,
              selectedLevel:-1,
              selectedRows: [],

              activeTab:0,
                deletedialog: false,
              deleteMultipleDialog:false,
                deleteId:0,
                id:"",
                projectType:"",
                projectName: "",
                projectNumber:"",
                projectLanguage:"",
              department:"",
                lastEdited:"",
                active:false,
                potentialIncidents: [],
                potentialIncidentsFiltered: [],
                filteredView:false,
                probabilityLevels: [],
                consequenceStrengths: [],
                search: "",
                headers: [
                    {
                        sortable: true,
                        text: this.$i18n.t("potentialIncident.logicalId"),
                        value: 'logicalId'
                    },
                    {
                        sortable: true,
                        text: this.$i18n.t("potentialIncident.workType"),
                        value: 'workTypeName'
                    },
                    {
                        sortable: true,
                        text: this.$i18n.t("potentialIncident.workOperation"),
                        value: 'workOperationName'
                    },
                    {
                        sortable: true,
                        text: this.$i18n.t("potentialIncident.location"),
                        value: 'locationName'
                    },
                    {
                        sortable: true,
                        text: this.$i18n.t("potentialIncident.incidentType"),
                        value: 'incidentTypeName'
                    },
                    {
                        sortable: true,
                        text: this.$i18n.t("potentialIncident.consequenceType"),
                        value: 'consequenceTypeName'
                    },
                    {
                        sortable: true,
                        text: this.$i18n.t("potentialIncident.risk"),
                        value: 'risk'
                    },
                    {
                        sortable: true,
                        text: this.$i18n.t("potentialIncident.riskAfterMeasures"),
                        value: 'riskAfterMeasures'
                    }


                ],
              copytoproject: {
                enabled:false,
                selectedRows:[],
                working:false,
                headers: [
                  {
                    sortable: true,
                    text: this.$i18n.t("location.name"),
                    value: 'name'
                  }
                  ],
                search:"",
                projects: []
           },



            }
        },
        methods: {
            openDeleteDialogue() {
                this.deletedialog = true
                this.deleteId=0
            },
            openPotentialIncidentDeleteDialogue(potentialIncidentId) {
                this.deletedialog = true
                this.deleteId = potentialIncidentId
            },
          openCopyToProjectDialogue(potentialIncidentId) {
              this.copytoproject.enabled = true
              api.getProjects(false).then(response => {
                this.copytoproject.projects = response
             })
          },
          confirmCopyIncidentsToPortal() {
              this.copytoproject.working = true
            let toProjectId = this.copytoproject.selectedRows.pop().id
            api.copyIncidentsToProject(this.id, toProjectId, this.selectedRows.map(ele=>ele.id)).then(response => {
                this.copytoproject.enabled = false
                this.copytoproject.selectedRows = []
                this.selectedRows = []
                this.copytoproject.working = false
                if (toProjectId === this.id) {
                  this.getPotentialIncidents(this.id)
                }
              }
            )  .catch(error => {
              this.$store.commit('setErrorMsg', error)
              console.log(error)

              //    this.errors.push(error)
            })

          },
          openDeleteMultipleDialogue() {
            this.deleteMultipleDialog = true
          },
          confirmDeleteMultiplePotentialIncidencts() {

            api.deletePotentialIncidents(this.selectedRows.map(ele=>ele.id)).then(response => {
              this.deleteMultipleDialog = false
              this.selectedRows = []
              this.getPotentialIncidents(this.id)
              //   console.log(response.data)
            })
              .catch(error => {
                this.$store.commit('setErrorMsg', error)
                console.log(error)
                //    this.errors.push(error)
              })



          },
            confirmDeleteProject() {

                api.deleteProject(this.id).then(response => {
                    this.deletedialog = false

                    this.$router.push({ name: 'ProjectList' })
                    //   console.log(response.data)
                })
                    .catch(error => {
                        this.$store.commit('setErrorMsg', error)
                        console.log(error)
                        //    this.errors.push(error)
                    })



            },
            confirmDeletePotentialIncident() {

                api.deletePotentialIncident(this.deleteId).then(response => {
                    this.deletedialog = false
                    this.deleteId =0
                    this.getPotentialIncidents(this.id)
                    //   console.log(response.data)
                })
                    .catch(error => {
                        this.$store.commit('setErrorMsg', error)
                        console.log(error)
                        //    this.errors.push(error)
                    })



            },
            closeDialogue() {
                this.deleteId =0
                this.deletedialog = false
              this.deleteMultipleDialog = false
                this.copytoproject.enabled = false
              this.copytoproject.selectedRows = []
            },
            filterIncidentsOnRiskBefore(consequenceStrength, probabilityLevel) {
              this.selectedCons = consequenceStrength
              this.selectedLevel = probabilityLevel
              this.filterOnRiskBefore = true
                this.potentialIncidentsFiltered = this.potentialIncidents.slice().filter(function(ele){return ele.consequence!=null && ele.probability!=null && ele.consequence.id==consequenceStrength && ele.probability.id==probabilityLevel})
                this.filteredView=true
            },
            filterIncidentsOnRiskAfter(consequenceStrength, probabilityLevel) {
              this.selectedCons = consequenceStrength
              this.selectedLevel = probabilityLevel
              this.filterOnRiskBefore = false
                this.potentialIncidentsFiltered = this.potentialIncidents.slice().filter(function(ele){return ele.consequenceAfterMeasures!=null && ele.probabilityAfterMeasures!=null &&  ele.consequenceAfterMeasures.id==consequenceStrength && ele.probabilityAfterMeasures.id==probabilityLevel})
                this.filteredView=true
            },
            clearFilterOnIncidents() {
                this.potentialIncidentsFiltered = this.potentialIncidents
                this.filteredView=false
            },
            getProject(projectid) {
                api.getProject(projectid).then(response => {
                    this.id = response.id
                    this.projectName= response.name
                    this.projectNumber = response.projectNumber
                    this.projectLanguage = languageUtil.getLanguageText(response.language)
                    this.projectType = response.projectType.name
                    this.department = response.department.name
                    this.active = response.active
                    this.lastEdited = response.lastEditedDate
                })
                    .catch(error => {
                        this.$store.commit('setErrorMsg', error)
                        console.log(error)
                        //    this.errors.push(error)
                    })
            },
            getPotentialIncidents(projectid) {
                api.getPotentialIncidents(projectid).then(response => {
                    this.potentialIncidents =response.map(function(ele) {
                             return{
                                'id':ele.id,
                                'logicalId':ele.logicalId,
                                'workTypeName':ele.workType.name,
                                "workOperationName":ele.workOperation.name,
                                "incidentTypeName":ele.incidentType.name,
                                "locationName":ele.location.name,
                                "consequenceTypeName":ele.consequenceType.name,
                                "risk":ele.risk,
                                "riskAfterMeasures":ele.riskAfterMeasures,
                                "consequence":ele.consequence,
                                "probability":ele.probability,
                                "consequenceAfterMeasures":ele.consequenceAfterMeasures,
                                "probabilityAfterMeasures":ele.probabilityAfterMeasures

                            }
                        }
                    )
                    this.potentialIncidentsFiltered = this.potentialIncidents
                })
                    .catch(error => {
                        this.$store.commit('setErrorMsg', error)
                        console.log(error)
                        //    this.errors.push(error)
                    })
            },
            switchActiveStatus() { api.switchActiveStatusOnProject(this.id).then(response => {
                this.active = !this.active
            })
                .catch(error => {
                    this.$store.commit('setErrorMsg', error)
                    console.log(error)
                    //    this.errors.push(error)
                })
            },
            cloneProject() {
                this.$router.push({ name: 'ProjectCreateFromProject', params: {"templateProjectId": this.id} })
            },
            showPotentialIncident(rowdata) {
              //  if (this.userHasAuthority('MANAGE_PROJECTS')) {
                  this.$router.push({ path: '/potentialIncidentShow/' + rowdata.id })
//                }
            },
            getLevel(obj) {
              if (obj==null || typeof obj != 'object') {
                return obj;
              } else {
                return obj.id;
              }
            },
            getRiskColor(probability, consequence) {
                return riskUtil.getRiskColor(probability, consequence)
            },
            getProbabilityLevels () {
                api.getProbabilityLevels().then(response => {
                    this.probabilityLevels= response.map(function(strength) { return {'id':strength.strength, 'name':strength.name + ' (' + strength.strength + ')'}})
                    //   console.log(response.data)
                })
                    .catch(error => {
                        this.$store.commit('setErrorMsg', error)
                        console.log(error)
                        //    this.errors.push(error)
                    })
            },
            getConsequenceStrengths() {
                api.getConsequenceStrengths().then(response => {
                    this.consequenceStrengths= response.map(function(strength) { return {'id':strength.strength, 'name':strength.name + ' (' + strength.strength + ')'}})
                })
                    .catch(error => {
                        this.$store.commit('setErrorMsg', error)
                        console.log(error)
                        //    this.errors.push(error)
                    })
            },
            addDeleteColumnIfApplicable() {
                if (this.userHasAuthority('MANAGE_PROJECTS')) {
                    this.headers.push(
                        {       sortable: false,
                            text: this.$i18n.t("global.delete"),
                            value: 'delete'
                        }
                    )
                }
            }

        },
        computed: {
            incidentsPerCellBefore() {
                var incidentsPerCellBefore = [];
                this.consequenceStrengths.forEach(stren=>{
                    var incidentsPerRow=  []
                    this.probabilityLevels.forEach(level=>{
                        incidentsPerRow.push( this.potentialIncidents.slice().filter(function(ele){return ele.consequence!=null && ele.probability!=null && ele.consequence.id==stren.id && ele.probability.id==level.id}).length)
                    })
                    incidentsPerCellBefore.push(incidentsPerRow)
                })
                return incidentsPerCellBefore;

            },
            incidentsPerCellAfter() {
                var incidentsPerCellAfter = [];
                this.consequenceStrengths.forEach(stren=>{
                    var incidentsPerRow=  []
                    this.probabilityLevels.forEach(level=>{
                        incidentsPerRow.push( this.potentialIncidents.slice().filter(function(ele){return ele.consequenceAfterMeasures!=null && ele.probabilityAfterMeasures!=null && ele.consequenceAfterMeasures.id==stren.id && ele.probabilityAfterMeasures.id==level.id}).length)
                    })
                    incidentsPerCellAfter.push(incidentsPerRow)
                })
                return incidentsPerCellAfter;

            }

        },
        mounted() {
            this.getProject(this.$route.params.id)
            this.getPotentialIncidents(this.$route.params.id)
            this.getConsequenceStrengths()
            this.getProbabilityLevels()
            this.addDeleteColumnIfApplicable()
        }
    }
</script>

